module.exports = __webpack_public_path__ + "img/errorNoMsg.2005426b.png";